/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {

  //********** Animations *************

  if (window.AOS) {
    AOS.init({once: true,offset: 0});
  }

  if ($('.TextAnimate').length) {
    $(function () {
      $('.TextAnimate').textillate({
        initialDelay: 0,
      });
    })
  }


  function parallaxInit() {
    document.querySelectorAll('.ParallaxScale').forEach((elem) => {
      basicScroll.create({
        elem: elem,
        from: 'top-bottom',
        to: 'bottom-top',
        direct: true,
        props: {
          '--scale': {
            from: 1.0,
            to: 1.2
          }
        }
      }).start()
    });

    document.querySelectorAll('.ParallaxTranslate').forEach((elem) => {
      basicScroll.create({
        elem: elem,
        from: 'top-middle',
        to: 'bottom-top',
        direct: true,
        props: {
          '--translateY': {
            from: '0',
            to: '-200px'
          }
        }
      }).start()
    });
  }
  setTimeout(parallaxInit, 1000);

  var $page = $('html, body');
  $('a[href*="#"]').click(function() {
    $page.animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 400);
    return false;
  });

  //********** Slide toggle function *************

  $(document).on('click', '.ariaToggleSlide', function(event){
    event.preventDefault();
    var $currentTarget = $(event.currentTarget);
    $currentTarget.toggleClass('Active');
    $currentTarget.attr('aria-expanded', $currentTarget.attr('aria-expanded')=='false' ? 'true' : 'false');
    var toggleID = $currentTarget.attr('aria-controls');
    $( '#'+ toggleID ).slideToggle();
  });

  $(document).on('click', '.ariaToggleSlideNextItem', function(event){
    event.preventDefault();
    var $currentTarget = $(event.currentTarget);
    $currentTarget.attr('aria-expanded', $currentTarget.attr('aria-expanded')=='false' ? 'true' : 'false');
    $currentTarget.next('.ToggleContent').slideToggle();
  });

  $(document).on('click', '[data-action="collapse-all"]', function(event){
    event.preventDefault();
    $('.ariaToggleSlideNextItem[aria-expanded="true"]').attr('aria-expanded', 'false').next('.ToggleContent').slideUp();
  });

  //***************** Scroll to captcha after newsletter form submit ****************
  if ($('#NewsletterFormWrapper').length) {
    (function () {
      var str = document.getElementById("NewsletterFormWrapper").innerHTML;
      var res = str.replace("/contact#footer-pre-footer", "/contact");
      document.getElementById("NewsletterFormWrapper").innerHTML = res;
    }());
  }

  //********************* Slick *****************

  (function initSlickSlider() {
    $('[data-action="slick-slideshow-init"]').each(function () {
      let $slider = $(this),
          config = null;
      if ($(this).attr('data-slick-config')) {
        config = $.parseJSON($(this).attr('data-slick-config'));

        if (config) {
          if (config.arrows) {
            config["prevArrow"] = '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/></svg></button>';
            config["nextArrow"] = '<button type="button" class="slick-next"><span class="sr-only">Next</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/></svg></button>';
          }
        }
        $slider.not('.slick-initialized').slick(config);
      }

    });
  })()

  var $animatedDots = $('.AnimatedDots');

  if ($animatedDots.length) {
    $animatedDots.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $('.AnimatedDots .slick-dots .slick-active').addClass('DotAnimate');
    });

    $animatedDots.on('afterChange', function(event, slick, currentSlide, nextSlide){
      $('.AnimatedDots .slick-dots li').removeClass('DotAnimate');
    });
  }

  //***************** Hiding tooltips *********************
  $(document).mouseup(function (e){
    var $tooltipItem = $('.tooltip-item');
    var $tooltipContent = $('.tooltip-overlay');
    var $tooltipButton = $('.tooltip-button');

    if (!$tooltipItem.is(e.target) && $tooltipItem.has(e.target).length === 0) {
      $tooltipContent.html('');
      $tooltipButton.removeClass('active').attr('aria-expanded', 'false');
    }
  });

  //********************* Locations button *****************

  $(document).on("click", '.LocationIWT__Button', function(e) {
    e.preventDefault();
    $('.LocationIWT__InputWrapper').slideToggle();
  });

  $('.LocationIWT__Input').keyup(function() {
    var value  = $('.LocationIWT__Input').val();
    var address= $('.LocationIWT__Submit').attr('data-address');
    var currentValue = "http://maps.google.com/maps?saddr=" + value + "&daddr=" + address

    $('.LocationIWT__Submit').attr('href', currentValue);
  })

  //********************* Tabs function *****************

  function tabs(container, button, content) {
    var $tabsContainer = $(container);
    var $tabButton = $tabsContainer.find(button);

    $tabButton.on('click', function () {
      var index = $(this).index();
      var $tab = $(container).find(content);

      if (!$(this).hasClass('Active')) {
        $tabButton.removeClass('Active');
        $(this).addClass('Active');
        $tab.hide().eq(index).fadeIn();
      }
    });
  }

  tabs('.ProductTabs','.ProductTabs__Button', '.ProductTabs__ContentItem' );
  tabs('.CollectionsList__Collection','.CollectionsList__Button', '.CollectionsList__TabItem' );

  //********************* Product info modal *****************
  var $productModalInfo = $('.ProductModal');

  $('[data-action="open-product-modal"]').on('click', function () {
    var modalId = $(this).attr('aria-controls');
    $(modalId).addClass('is-visible');
    $(modalId).attr('aria-hidden', 'false');
    $('body').addClass('no-scroll-mobile');
  });

  $('[data-action="close-product-modal"]').on('click', function () {
    $productModalInfo.removeClass('is-visible');
    $productModalInfo.attr('aria-hidden', 'true');
    $('body').removeClass('no-scroll-mobile');
  });

  $(document).mouseup(function (e) {
    var $productModalInfo = $('.ProductModal.is-visible');
    if ($productModalInfo.has(e.target).length === 0) {
      $productModalInfo.removeClass('is-visible');
      $productModalInfo.attr('aria-hidden', 'true');
      $('body').removeClass('no-scroll-mobile');
    }
  });

  //********************* Quick add to cart *****************

  // Setup listeners to add/subtract from the input
  $(document).on('click keyup', '.js-qty__adjust', function(e) {
    if ( e.type === 'keyup' && e.keyCode !== 13 ) return;

    var el = $(this),
        qtySelector = el.siblings('.js-qty__num'),
        qty = parseInt(qtySelector.val().replace(/\D/g, ''));

    // Make sure we have a valid integer
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    // Add or subtract from the current quantity
    if (el.hasClass('js-qty__adjust--plus')) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 0) qty = 1;
    }
    // Update the input's number
    qtySelector.val(qty).trigger('change');
  });

  // All quantity input value change on up/down arrows key press
  $(document).on('keyup', '.js-qty__num', function(e) {
    // On arrow up key press (38)
    if ( e.keyCode == 38 ) {
      $(this).siblings( '.js-qty__adjust--plus' ).trigger( 'click' );
    }
    // On arrow down key press (40)
    if ( e.keyCode == 40 ) {
      $(this).siblings( '.js-qty__adjust--minus' ).trigger( 'click' );
    }
  });

  $(document).on('click', '[data-action="quick-add"]', function(evt) {
    evt.preventDefault();
    var $wrapper = $(this).parents('.QuantityWrapper__Outer');
    var quantity = $wrapper.find('.js-qty__num').val();
    var data = {
      id: evt.target.getAttribute('data-variant-id'),
      quantity: quantity
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function () {
        document.dispatchEvent(new CustomEvent('product:added'));
      },
      error: function (error) {
        if (error.status == 422) {
          var $errorMessage = $wrapper.find('.AddProduct__ErrorMessage');
          $errorMessage.text(error.responseJSON.description).fadeIn('slow');

          setTimeout(function () {
            $errorMessage.fadeOut('slow').text('');
          }, 5000);
        }
      }
    })
  });
  
  // Recommended Product Change Bundle
  
  $('.RecommendedProductForm .ProductForm__BundleButton').click(function() {
    $(this).closest('.ProductForm__BundleList').find('.ProductForm__BundleButton').removeClass('Active');
  	$(this).addClass('Active');
    
    var rec_label = $(this).attr('data-bundle-label');
    var rec_text = $(this).attr('data-bundle-text');
    var rec_atpDate = $(this).attr('data-variant-atp');
    var rec_atpDateLong = $(this).attr('data-variant-atp-long');
    var today = new Date().toISOString().slice(0, 10);

	$(this).parent().next().find('.ProductForm__BundleLabel').html(rec_label);
	$(this).parent().next().find('.ProductForm__BundleText').html(rec_text);
    if (rec_atpDate <= today) {
      $('.ProductForm__BundleATP__value').html('Today');
    } else {
      $('.ProductForm__BundleATP__value').html(rec_atpDateLong);
    };
    
    var rec_selectedId = $(this).attr('data-variant-id');
    $('#rec-bundle-select option[selected]').removeAttr('selected');
    $('#rec-bundle-select option[value="' + rec_selectedId + '"]').attr('selected', 'selected');
  });
  
  // Recommended Product Add to Cart
  
  $(document).on('click', '[data-action="rec-add-to-cart"]', function(evt) {
    evt.preventDefault();
    var $wrapper = $(this).parents('.QuantityWrapper__Outer');
    var bundleSelectVal = $('#rec-bundle-input').val();
    var quantity = $wrapper.find('.js-qty__num').val();
    var bundleId = $('#rec-bundle-select option[selected]').attr('data-bundle-id');
    var additionalProduct = $('#rec-bundle-select option[selected]').attr('data-bundle-additional-product');
    var bundleInputVal = $('#rec-bundle-select').val();
    
    var formData = {
      items: [
        {
          id: bundleInputVal,
          quantity: quantity,
          properties: {
            'BundleId': bundleId,
            'AdditionalProduct': additionalProduct
          }
        },
        {
          id: bundleSelectVal,
          quantity: quantity,
          properties: {
            'BundleId': bundleId,
            'AdditionalProduct': additionalProduct
          }
        }
      ]
    }
        
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: formData,
      success: function () {
        document.dispatchEvent(new CustomEvent('product:added'));
      },
      error: function (error) {
        if (error.status == 422) {
          var $errorMessage = $wrapper.find('.AddProduct__ErrorMessage');
          $errorMessage.text(error.responseJSON.description).fadeIn('slow');

          setTimeout(function () {
            $errorMessage.fadeOut('slow').text('');
          }, 5000);
        }
      }
    })
  });
  
  // Mini Cart Recommended Product Change Bundle
  $(document).on('click', '.CartRecommended .ProductForm__BundleButton', function() {
    $(this).closest('.ProductForm__BundleList').find('.ProductForm__BundleButton').removeClass('Active');
    $(this).addClass('Active');

    var rec_label = $(this).attr('data-bundle-label');
    var rec_text = $(this).attr('data-bundle-text');
    var rec_atpDate = $(this).attr('data-variant-atp');
    var rec_atpDateLong = $(this).attr('data-variant-atp-long');
    var today = new Date().toISOString().slice(0, 10);

    $(this).parent().next().find('.ProductForm__BundleLabel').html(rec_label);
    $(this).parent().next().find('.ProductForm__BundleText').html(rec_text);
    if (rec_atpDate <= today) {
      $('.ProductForm__BundleATP__value').html('Today');
    } else {
      $('.ProductForm__BundleATP__value').html(rec_atpDateLong);
    };

    var rec_selectedId = $(this).attr('data-variant-id');
    $('#cart-rec-bundle-select option[selected]').removeAttr('selected');
    $('#cart-rec-bundle-select option[value="' + rec_selectedId + '"]').attr('selected', 'selected');
  });
  
  // Mini Cart Recommended Product Add to Cart
  
  $(document).on('click', '[data-action="cart-rec-add-to-cart"]', function(evt) {
    evt.preventDefault();
    var $wrapper = $(this).parents('.QuantityWrapper__Outer');
    var bundleSelectVal = $('#cart-rec-bundle-input').val();
    var quantity = $wrapper.find('.js-qty__num').val();
    var bundleId = $('#cart-rec-bundle-select option[selected]').attr('data-bundle-id');
    var additionalProduct = $('#cart-rec-bundle-select option[selected]').attr('data-bundle-additional-product');
    var bundleInputVal = null;
    if ($('#cart-rec-bundle-select').length) {
    	var bundleInputVal = $('#cart-rec-bundle-select').val();
    } else {
    	var bundleInputVal = $wrapper.siblings('.ProductForm__Variants').find('input').val();
    }
    
    if ($('#cart-rec-bundle-select').length) {
      var formData = {
        items: [
          {
            id: bundleInputVal,
            quantity: quantity,
            properties: {
              'BundleId': bundleId,
              'AdditionalProduct': additionalProduct
            }
          },
          {
            id: bundleSelectVal,
            quantity: quantity,
            properties: {
              'BundleId': bundleId,
              'AdditionalProduct': additionalProduct
            }
          }
        ]
      }
    } else {
      var formData = {
        form_type: 'product',
        quantity: quantity,
        id: bundleInputVal
      }
    }
        
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: formData,
      success: function () {
        document.dispatchEvent(new CustomEvent('product:added'));
      },
      error: function (error) {
        if (error.status == 422) {
          var $errorMessage = $wrapper.find('.AddProduct__ErrorMessage');
          $errorMessage.text(error.responseJSON.description).fadeIn('slow');

          setTimeout(function () {
            $errorMessage.fadeOut('slow').text('');
          }, 5000);
        }
      }
    })
  });
  
//   $('[data-action="cart-rec-add-to-cart"]').click(function() {
//     console.log('hi 1');
//     var sidebarCartContainer = $('#sidebar-cart .Drawer__Content');
//     if (sidebarCartContainer.siblings('.DrawerFooter').length) {
//     	console.log('hi 2');
//     }
//   });

  //*********************Cart zip code functional *****************

  $(document).on('click', '.CartSummary__ZipButton', function() {
    var zipcodes = $(this).attr('data-zipcode-list').split('-');
    var inputValue = $('.CartSummary__ZipInput').val();

    if (inputValue) {
      if (inputValue.length >= 5 && zipcodes.includes(inputValue)) {
        $('.CartSummary__ZipText, .DeliveryInfo, .CartSummary__ZipInputWrapper, .DeliveryInfo__NotQualify').addClass('hidden');
        $('.DeliveryInfo__Qualify, .CartSummary__ZipResult').removeClass('hidden');
        $('.ZipResult__Code').html(inputValue);
      } else {
        $('.CartSummary__ZipInputWrapper, .DeliveryInfo, .CartSummary__ZipText').addClass('hidden');
        $('.CartSummary__ZipResult, .DeliveryInfo__NotQualify').removeClass('hidden');
        $('.ZipResult__Code').html(inputValue);
      }
    }
  });

  $(document).on('click', '.ZipResult__UpdateBtn', function() {
    $('.CartSummary__ZipInputWrapper, .DeliveryInfo, .CartSummary__ZipText').removeClass('hidden');
    $('.CartSummary__ZipResult, .DeliveryInfo__Qualify .DeliveryInfo__NotQualify, .DeliveryInfo__Qualify').addClass('hidden');
  });
});
